// extracted by mini-css-extract-plugin
export default {"mobileBreakPoint":"780px","title":"title_title__HWRHR"};